import * as React from 'react';
import { Session } from '../services/Store';

export default function StartPage() {
    return (
        <div className="start">
            <h1>Kite Colorizer</h1>
            <p className="teaser">
                This is an approach to organize the various kite design
                colorizer templates in the web and maybe advance them a little.{' '}
                <br />
                The goal is to on one hand make the colorizer usable on mobile
                devices and also give the user a localstorage-based design and
                build managment.
            </p>
            <hr />
            <div style={{ display: 'flex' }}>
                <button
                    onClick={() => Session.setPage('kite')}
                    style={{ marginRight: '1rem' }}
                >
                    get started
                </button>
                <button onClick={() => Session.setPage('templates')}>
                    look at the templates
                </button>
            </div>
            <hr />
            <p className="note">
                This is project is subject to development and might change at
                anytime. feedback appreciated!
            </p>

            <h2>Features</h2>
            <ul className="copy-list">
                <li>Manage your colorized build drafts.</li>
                <li>Create new designs from a growing number of templates.</li>
                <li>Select different materials like Ikarex or Chikara ...</li>
                <li>Take notes for the various parts in the part manager.</li>
                <li>Export & import drafts.</li>
                <li>... more to come :-)</li>
            </ul>
            <h2>Credits</h2>
            <p>
                THX to{' '}
                <a href="https://www.kareloh.com/" target="_blank">
                    kareloh.com
                </a>{' '}
                for his awesome work and for sharing many open source kite plans
                with the community,{' '}
                <a href="https://www.drachenforum.net/" target="_blank">
                    drachenforum.net
                </a>{' '}
                for inspiration and knowlegde, to everybody who provided the
                already existant colorizers that serve as a basis for the
                templates and everyone supporting me on this project.
                <br />
                The origins of the colorizer can be found here:{' '}
                <a href="https://drive.google.com/drive/folders/0B3sL-C4hPI2QeFYta3hqMWZVZXM">
                    origins of the colorizer
                </a>
            </p>
            <h2>How-To</h2>
            <p className="note">
                As of now selecting a draft will skip unsaved changes without
                confirmation, same goes for deleting. So do not forget to save!
            </p>
            <p>
                The best way to start is to <strong>choose a template</strong>{' '}
                from the template list and start coloring a draft.
            </p>
            <p>
                Saved drafts appear in the <strong>manage drafts</strong> list
                that can be found in the drawer menu on the left side. Open it
                by clicking on the burger icon in the upper left corner. Here
                you can also delete your drafts.
            </p>
            <p>
                In <strong>the kite view</strong> you can -- besides the
                coloring -- rename your draft, copy the draft and change the
                template of your draft. This can be done by clicking on the
                "options" button.
                <br />
                You can toggle on a decorative shadow, skip through the draft
                list and -- if available -- see some information about the kite
                design along with links to build plans or a manufacturer site.
                <br />
                <em>Please note:</em> some templates might have restrictions
                like precolored, non-editable panels, limited material etc. due
                to the designers demand which i want to respect. In these cases
                information or extra controls will be shown.
            </p>
            <p>
                In <strong>the parts view</strong> you can examine all parts
                (that are provided by the template), change their name and type
                and take notes for each part.
            </p>
            <p>
                In <strong>export/import view</strong> you can export your
                current draft (including unsaved changes) or select one ore more
                drafts to be exported.
                <br />
                To import a file choose a JSON file that was exported via this
                colorizer. The available drafts show up in the dialog from where
                you can remove drafts from the import payload. Hit "import" and
                the drafts show up in your draft list :-).
            </p>
        </div>
    );
}
